// utils/cleanMarkdown.js
export function cleanMarkdown(text) {
  if (!text) return "";

  let s = text.trim();

  // Remove triple-backtick fences if AI wraps the rubric in ```
  if (s.startsWith("```") && s.endsWith("```")) {
    s = s.replace(/^```[\s\S]*?\n/, "").replace(/\n```$/, "");
  }

  // Remove extra quotes if AI wraps the text in " "
  if ((s.startsWith('"') && s.endsWith('"')) || (s.startsWith("'") && s.endsWith("'"))) {
    const inner = s.slice(1, -1);
    // only unwrap if it looks like Markdown
    if (inner.includes("**") || inner.includes("#") || inner.includes("- ")) {
      s = inner;
    }
  }

  // Unescape common escaped Markdown markers: \* \_ \` etc.
  s = s.replace(/\\\*/g, "*").replace(/\\_/g, "_").replace(/\\`/g, "`");

  // Remove markdown formatting symbols
  // Remove bold formatting: **text** or __text__
  s = s.replace(/\*\*(.+?)\*\*/g, "$1");
  s = s.replace(/__(.+?)__/g, "$1");
  
  // Remove italic formatting: *text* or _text_
  s = s.replace(/\*(.+?)\*/g, "$1");
  s = s.replace(/_(.+?)_/g, "$1");
  
  // Remove heading markers: # ## ### etc.
  s = s.replace(/^#{1,6}\s+/gm, "");
  
  // Remove inline code backticks: `code`
  s = s.replace(/`(.+?)`/g, "$1");

  return s;
}

// optional helper
export function generateCleanRubric(rawRubricText) {
  return cleanMarkdown(rawRubricText);
}
